export default __webpack_public_path__ + "static/media/3dots.da3de818.svg";